export default {
  baseStyle: {
    color: 'gray.900',
  },
}
